const coursetypegroups = {
	title: "Course Type Groups",
	new_coursetypegroup: "New Course Type Group",
	edit_coursetypegroup: "Edit Course Type Group: {name}",
	view_coursetypegroup: "View Course Type Group: {name}",
	list_title: "List of Course Type Groups",
	list_subtitle: "Manage Course Type Groups",
	create_title: "Create New Course Type Group",
	update_title: "Update Course Type Group",
	details_title: "Course Type Group Details",
	id: "ID",
	name: "Name",
	category: "Category",
	status: "Status",
	type: "Type",
	available_to_all: "Available to all",
	coursetype_mandatory: "Course type mandatory",
};
export default coursetypegroups;